// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7shRX","colBig":"styles_colBig__31_55","colSmall":"styles_colSmall__Y_lNK","shopifyNameWrapper":"styles_shopifyNameWrapper__13WAA"};